import { clearMaxChannelData, clearWhatsappChannelData } from '../../store/slices/channels'
import {
   channels_selectMaxQrCode,
   channels_selectMaxQrLoading,
   channels_selectMaxSourceId,
   channels_selectQrCode,
   channels_selectQrLoading,
   channels_selectSourceId
} from '../../store/slices/channels/selectors'
import {
   createMaxChannel,
   createWhatsappChannel,
   fetchMaxQR,
   fetchWhatsappQR
} from '../../store/slices/channels/thunk-creators'
import { channelTypes } from '../../utils/constants'
import { instructions as maxInstructions } from '../AddMaxPage/instructions'
import { instructions as whatsappInstructions } from '../AddWhatsappPage/instructions'

const qrChannelConfigMap = {
   [channelTypes.WHATSAPP]: {
      title: 'Whatsapp',
      description: 'Небольшая инструкция по подключению канала WhatsApp:',
      instructions: whatsappInstructions,
      selectQrLoading: channels_selectQrLoading,
      selectQrValue: channels_selectQrCode,
      selectSourceId: channels_selectSourceId,
      fetchQrThunk: fetchWhatsappQR,
      startScanThunk: createWhatsappChannel,
      clearAction: clearWhatsappChannelData
   },
   [channelTypes.MAX]: {
      title: 'MAX',
      description: 'Небольшая инструкция по подключению канала MAX:',
      instructions: maxInstructions,
      selectQrLoading: channels_selectMaxQrLoading,
      selectQrValue: channels_selectMaxQrCode,
      selectSourceId: channels_selectMaxSourceId,
      fetchQrThunk: fetchMaxQR,
      startScanThunk: createMaxChannel,
      clearAction: clearMaxChannelData
   }
}

export const getQrChannelConfig = (channelType) => qrChannelConfigMap[channelType]
